import { render, staticRenderFns } from "./GroupMenu.vue?vue&type=template&id=0660d096&scoped=true"
import script from "./GroupMenu.vue?vue&type=script&lang=js"
export * from "./GroupMenu.vue?vue&type=script&lang=js"
import style0 from "./GroupMenu.vue?vue&type=style&index=0&id=0660d096&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0660d096",
  null
  
)

export default component.exports